export class EmissionSource {
	id!: number;
	textSource!: string;
	cdEnergyType!: string;
}
